import { useCallback, useMemo, useState } from 'react';

/**
 * Scrollable modal body with a scrollbar that only shows on hover (CT-5192 /
 * CT-5195).
 *
 * Duplicated from
 * `aims-os-governance/src/domains/truth-plane/hooks/useScrollableModalBody.js`
 * per CT-5183's "duplicate locally" rule — apps never import from
 * `@aimsos/governance`.
 *
 * @returns {{ bodyClassName: string, bodyProps: object }}
 */
export const useScrollableModalBody = () => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = useCallback(() => setHovered(true), []);
  const handleMouseLeave = useCallback(() => setHovered(false), []);

  return useMemo(
    () => ({
      bodyClassName: 'scrollbar-aimsos-auto min-h-0 flex-1 overflow-y-auto',
      bodyProps: {
        'data-scrollbar-hover': hovered ? 'true' : undefined,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      },
    }),
    [handleMouseEnter, handleMouseLeave, hovered],
  );
};

export default useScrollableModalBody;
